import React from 'react';
import { useState } from 'react';
import './Navbar.css';
import facebookIcon from '../../images/socials/facebook.png';
import twitterIcon from '../../images/socials/twitter.png';
import instagramIcon from '../../images/socials/instagram.png';
import emailIcon from '../../images/socials/email.png';
import { link_items } from "../../utils";
import gneetyLogo from '../../images/Gneety Logo - white transparent.png'
import omalogo from '../../images/Oma-New-Logo.png';
import omaTransparentLogo from '../../images/oma-transparent-logo.png';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebook } from "react-icons/fa6";
import { CiMail } from "react-icons/ci";


export default function Header() {

  const [isActive, setIsActive] = useState(false);

  const handleToggle = () => {
    setIsActive(!isActive);
  };


  return (
    <div className=''>
      <header>
        <div className="nav-logo" onClick={() => setIsActive(false)}> 
          <Link to="/"> 
            <img src={omalogo} alt="logo" />
          </Link> 
        </div>

        <div className={`toggle ${isActive ? "active" : ""}`} 
        onClick={handleToggle}></div>


        <div className={`navigation ${isActive ? "nav-active" : "nav-not-active"}`}>
          <ul>
            {
              link_items?.map((link, link_index) => {
                return (
                  <li key={link_index}>
                    <Link to={link.url} onClick={() => setIsActive(false)}> 
                      {link.title} 
                      {link.title.toLowerCase() == 'resources' && <span className='nav-new'> <sup> new </sup> </span> } 
                    </Link>
                  </li>
                )
              })
            }
          </ul>

          <div className="social-bar">
            <ul>
              <li>
                <a href="https://web.facebook.com/omamediasupreme" target="_blank">
                  <FaFacebook />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/oma.media.space/" target="_blank">
                  <FaInstagram />
                </a>
              </li>
            </ul>
            <a href="mailto:omamedia@gmail.com" target="_blank" className="email-icon">
              <CiMail />
            </a>
          </div>
        </div>
      </header>
    </div>
  )
}
